import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';  
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { GlobalServices } from './global.services';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { PlanComponent } from './plan/plan.component';
import { PaymentComponent } from './payment/payment.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { SiteMapComponent } from './site-map/site-map.component';
import { CareerComponent } from './career/career.component';
import { ContactComponent } from './contact/contact.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { FounderComponent } from './about-us/founder/founder.component';
import { MissionComponent } from './about-us/mission/mission.component';
import { WhyBookWithUsComponent } from './why-book-with-us/why-book-with-us.component';
import {NgxJsonLdModule} from '@ngx-lite/json-ld';
import {ForgotpassComponent} from './forgotpass/forgotpass.component';
import { ModalPopUpComponent } from './modal-pop-up/modal-pop-up.component';
import { PaymentConfirmationComponent } from './payment-confirmation/payment-confirmation.component';
import { PartnersComponent } from './partners/partners.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import {PartnersignupComponent} from './partnersignup/partnersignup.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import {VerifymailComponent} from './verifymail/verifymail.component';
import { FaqsComponent } from './faqs/faqs.component';
import { NotfoundComponent } from './notfound/notfound.component';
import {CorporateComponent} from './corporate/corporate.component';
import { OnboardQuestionsComponent } from './onboard-questions/onboard-questions.component';
import { OnboardQuestionDetailComponent } from './onboard-question-detail/onboard-question-detail.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SignupmoduleModule } from './signupmodule/signupmodule.module';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatNativeDateModule} from '@angular/material/core';
import {MatIconModule} from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UserDashboardService } from './services/user-dashboard.service';
import { MembershipComponent } from './membership/membership.component';
import { NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng5SliderModule } from 'ng5-slider';
// import {  HTTP_INTERCEPTORS } from '@angular/common/http';
import { MembershipFreeComponent } from './membership-free/membership-free.component';
import { MembershipDiscountComponent } from './membership-discount/membership-discount.component';
import { VariationFitnessComponent } from './variation-fitness/variation-fitness.component';
import { LogoutComponent } from './logout/logout.component';
import { ToastrModule } from 'ngx-toastr';
import { AssesmentFormComponent } from './assesment-form/assesment-form.component';
import { PointSubmissionFormComponent } from './points-submission-form/points-submission-form.component';
import { VenderSignupComponent } from './vender/vender-signup/vender-signup.component';
import { VenderSignupfreeComponent } from './vender/vender-signup-free/vender-signupfree.component';
import { B2bteamsComponent } from './b2bteams/b2bteams.component';
import { B2bteamsConfirmationComponent } from './b2bteams-confirmation/b2bteams-confirmation.component';
import { NewteamsComponent } from './newteams/newteams.component';
import { RewardscardComponent } from './rewardscard/rewardscard.component';
import { Signupmoduleb2cModule } from './signupmoduleb2c/signupmoduleb2c.module';
import { RewardsConfirmationComponent } from './rewards-confirmation/rewards-confirmation.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    LoginComponent,
    SignupComponent,
    PlanComponent,
    PaymentComponent,
    PrivacyPolicyComponent,
    TermsConditionsComponent,
    SiteMapComponent,
    CareerComponent,
    ContactComponent,
    AboutUsComponent,
    FounderComponent,
    MissionComponent,
    WhyBookWithUsComponent,
    ForgotpassComponent,
    // ModalPopUpComponent,
    PaymentConfirmationComponent,
    PartnersComponent,
    SubscriptionComponent,
    PartnersignupComponent,
    ResetpasswordComponent,
    VerifymailComponent,
    FaqsComponent,
    NotfoundComponent,
    CorporateComponent,
    OnboardQuestionsComponent,
    OnboardQuestionDetailComponent,
    SafeHtmlPipe,
    DashboardComponent,
    MembershipComponent,
    MembershipFreeComponent,
    MembershipDiscountComponent,
    VariationFitnessComponent,
    LogoutComponent,
    AssesmentFormComponent,
    PointSubmissionFormComponent,
    VenderSignupComponent,
    VenderSignupfreeComponent,
    B2bteamsComponent,
    B2bteamsConfirmationComponent,
    NewteamsComponent,
    RewardscardComponent,
    RewardsConfirmationComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxJsonLdModule,
    Ng5SliderModule,
    SlickCarouselModule,
    DragDropModule,
    SignupmoduleModule,
    Signupmoduleb2cModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatIconModule,
    BrowserAnimationsModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgbRatingModule,
    ToastrModule.forRoot()
  ],
  providers: [
    GlobalServices,
    UserDashboardService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
